/**
 * Coordinates the unmounting of the bootstrap skeleton (mounted early in a separate React root)
 * with the main app's content readiness. This prevents a visual flash that would occur if the
 * skeleton unmounted before the main app's content is ready to display.
 *
 * Flow:
 * 1. Bootstrap skeleton mounts early in its own React root
 * 2. Main app mounts and begins loading database content
 * 3. When DatabaseContentLoader is ready to render actual content, it calls setDatabaseContentReady()
 * 4. The bootstrap skeleton then unmounts, revealing the ready content underneath
 */
let contentReady = false;
let onContentReadyCallback: (() => void) | null = null;
let loadingProgress = 0;

export const setDatabaseContentReady = () => {
  contentReady = true;
  loadingProgress = 0;
  onContentReadyCallback?.();
};

export const getLoadingProgress = () => loadingProgress;

export const setLoadingProgress = (value: number) => {
  loadingProgress = value;
};

export const isDatabaseContentReady = () => contentReady;

export const onDatabaseContentReady = (callback: () => void) => {
  if (contentReady) {
    callback();
  } else {
    onContentReadyCallback = callback;
  }
};

export const resetDatabaseLoadingState = () => {
  contentReady = false;
  onContentReadyCallback = null;
  loadingProgress = 0;
};
